import React from 'react';
import * as Sentry from '@sentry/react';
import ErrorPage from '../../pages/ErrorPage';

const ErrorBoundaryWrapper = ({ children }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={() => {
        return (
          <ErrorPage
            showActionButton={true}
            message=""
          />
        );
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundaryWrapper;
